import { useEffect, useState } from "react";
import { useShallow } from "zustand/react/shallow";
import ExpandableSection from "@/components/job/ExpandableSection";
import { Button } from "@/components/ui/button";
import { TextInput } from "@/components/ui/textInput";
import useCUMechanicalJobStore from "@/store/useCUMechanicalJobStore";

const toSafeString = (value: unknown): string => {
  if (value === null || value === undefined) {
    return "";
  }
  return String(value);
};

export function CheckedByDetails() {
  const { sections, setChecks } = useCUMechanicalJobStore(
    useShallow((state) => ({
      sections: state.sections,
      setChecks: state.setChecks,
    }))
  );

  const checks = sections.checks;
  const [isExpanded, setIsExpanded] = useState(true);
  const [checkedByFirstName, setCheckedByFirstName] = useState("");
  const [checkedByLastName, setCheckedByLastName] = useState("");

  const needsCheckedBy = checks.data.do_you_wish_to_change_default_checked_by === true;
  const shouldShow = checks.isDataFilled && needsCheckedBy;

  useEffect(() => {
    if (!shouldShow) {
      setCheckedByFirstName("");
      setCheckedByLastName("");
      return;
    }
    setCheckedByFirstName(toSafeString(checks.data.checked_by_first_name));
    setCheckedByLastName(toSafeString(checks.data.checked_by_last_name));
  }, [checks.data, shouldShow]);

  const checkedByFirstNameValid = !needsCheckedBy || checkedByFirstName.trim().length > 0;
  const checkedByLastNameValid = !needsCheckedBy || checkedByLastName.trim().length > 0;
  const canSave = checkedByFirstNameValid && checkedByLastNameValid;

  const isComplete =
    !needsCheckedBy ||
    (checks.data.checked_by_first_name !== null &&
      checks.data.checked_by_first_name !== undefined &&
      checks.data.checked_by_last_name !== null &&
      checks.data.checked_by_last_name !== undefined);

  const status = !shouldShow ? "hidden" : isComplete ? "done" : "open";

  const handleSave = () => {
    setChecks({
      data: {
        ...checks.data,
        checked_by_first_name:
          needsCheckedBy && checkedByFirstName.trim().length > 0 ? checkedByFirstName.trim() : null,
        checked_by_last_name: needsCheckedBy && checkedByLastName.trim().length > 0 ? checkedByLastName.trim() : null,
      },
      status: "done",
    });
    setIsExpanded(false);
  };

  return (
    <ExpandableSection
      isExpanded={isExpanded}
      setIsExpanded={() => setIsExpanded((prev) => !prev)}
      status={status}
      title="Checked By"
    >
      <div className="flex flex-col gap-3">
        {needsCheckedBy && (
          <>
            <TextInput
              label="Checked By First Name"
              placeholder="Enter checked by first name"
              value={checkedByFirstName}
              onChange={(e) => {
                setCheckedByFirstName(e.currentTarget.value);
              }}
            />

            <TextInput
              label="Checked By Last Name"
              placeholder="Enter checked by last name"
              value={checkedByLastName}
              onChange={(e) => {
                setCheckedByLastName(e.currentTarget.value);
              }}
            />
          </>
        )}
      </div>

      <div className="mt-4 flex justify-end">
        <Button onClick={handleSave} disabled={!canSave}>
          Save
        </Button>
      </div>
    </ExpandableSection>
  );
}
